import React, { useEffect } from "react";

const useDfpSlot = ({ path, size, id }) => {
  useEffect(
    () => {
      const googletag = global.googletag || {};
      window.googletag = window.googletag || { cmd: [] };
      window.refreshSlotKeys = JSON.parse('["s7"]');
      window.slotsToRefresh = [];
      googletag.cmd.push(function() {
        var REFRESH_KEY = "refresh";
        var REFRESH_VALUE = "true";

        googletag
          .defineSlot(path, size, id)
          .setTargeting(REFRESH_KEY, REFRESH_VALUE)
          .setTargeting("test", "event")
          .addService(googletag.pubads());

        // Number of seconds to wait after the slot becomes viewable
        var SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;

        googletag.pubads().addEventListener("impressionViewable", function(event) {
          var slot = event.slot;
          if (slot.getTargeting(REFRESH_KEY).indexOf(REFRESH_VALUE) > -1) {
            setTimeout(function() {
              googletag.pubads().refresh([slot]);
            }, SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000);
          }
        });
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();

        googletag.enableServices();
      });
      googletag.cmd.push(function() {
        googletag.display(id);
      });
    },
    [path, size, id]
  );
};

const CustomAdslot = params => {
  useDfpSlot({
    path: params.path,
    size: params.size,
    id: params.id
  });
  return <div id={params.id} />;
};

export default CustomAdslot;
